'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_PAGE_NAME = exports.UPDATE_HEADER_SIZE = exports.SET_CAN_SCROLL_TO_TOP = undefined;

var _doctifyUtils = require('doctify-utils');

var SET_CAN_SCROLL_TO_TOP = exports.SET_CAN_SCROLL_TO_TOP = 'APP:SET_CAN_SCROLL_TO_TOP';

var UPDATE_HEADER_SIZE = exports.UPDATE_HEADER_SIZE = 'APP:UPDATE_HEADER_SIZE';
var SET_PAGE_NAME = exports.SET_PAGE_NAME = 'APP:SET_PAGE_NAME';

var AppActions = {
    canScrollToTop: function canScrollToTop(status) {
        return {
            type: SET_CAN_SCROLL_TO_TOP,
            status: status
        };
    },
    updateHeaderSize: function updateHeaderSize(newHeaderHeight) {
        return {
            type: UPDATE_HEADER_SIZE,
            payload: {
                headerHeight: newHeaderHeight
            }
        };
    },
    setPageName: function setPageName(pageName) {
        return {
            type: SET_PAGE_NAME,
            payload: {
                pageName: pageName
            }
        };
    }
};

exports.default = AppActions;